# out: $1.js, compress: false, sourcemap: true
module = ->

  #reloadBinded = false

  class window.AjaxForm


    constructor: (@page, @submitter, @reload)->
      # Определяем тег <form>
      @form = @submitter.closest("form")

      # Связываем dom-элемент с объектом-формой
      $.data($(@form), "ajaxform", this)

      # Имя сущности - используется для определения обработчиков.
      # Приоритетно по сравнению с определением через атрибуты.
      @dbName = @form.attr("db-name")

      # URL обработчика формы
      @href = @form.attr("action")

      # Сообщение при успешной отправке формы. Замещает собой сообщение от
      # сервера.
      @successMessage = @form.attr('msg-success')

      # Определяем метод отправки формы
      @method = @form.attr('method')
      @method = 'POST' if !@method
      @method = @method.toUpperCase()

      @isGET  = @method == "GET"
      @isPOST = @method == "POST"

      # Не помню, для чего - проверить
      if @page && @page.handleDateInterfaces
        @page.handleDateInterfaces(@form)

          # @form.find('.form-result-success').get(0).scrollIntoView()

          # @form.find('.form-result-success').get(0).scrollIntoView()

      # Элементы с атрибутом action = submit, расположенные ВНУТРИ формы
      # осуществляют ее отправку
      @form.find('[action=submit]').click ()=>
        $(@form).submit()



      # @newAttachmentName =
      #   @form.attr('new-attachment-name') || "#{@dbName}_file_{index}"
      # @removeAttachmentName =
      #   @form.attr('remove-attachment-name') || "remove_#{@dbName}_file"

      @onDone = undefined

      @stack = new FileHolderStack(@form)

      @preExecuteName = @form.attr('pre-execute');
      @preExecute = window[@preExecute] if @preExecuteName

      @stateChangeHandlerName = @form.attr('state-change-handler');

      @apply = $("[ajax-form-apply=#{@form.attr('id')}]")
      @apply.off 'click'
      @apply.click ()=>
        @send({edit: true, state: 'edit', reload: @reload})

      @save = $("[ajax-form-save=#{@form.attr('id')}]")
      @save.off 'click'
      @save.click (event)=>
        @send({back:true, reload: $(event.target).attr('ajax-reload-after')})

      @copy = $("[ajax-form-copy=#{@form.attr('id')}]")
      @copy.off 'click'
      @copy.click ()=>
        @send({state: 'copy'})

      @add = $("[ajax-form-add=#{@form.attr('id')}]")
      @add.off 'click'
      @add.click ()=>
        @send({clear:true, state: 'new'})

      if @dbName && window[@dbName] && window[@dbName]["onInit"]
        window[@dbName]["onInit"](this)

    ###
      Формирует новое сообщение внутри формы.
      @param messageContainerClass - класс контейнера внутри формы для сообщения
      @param data - текст сообщения
    ###
    newInFormMessage: (messageContainerClass, data)->
      $successMessageContainer = @form.find(".#{messageContainerClass}")
      $successMessageContainer.html(data)
      $('html, body').animate({
        scrollTop: $successMessageContainer.offset().top - $("header").height()
      }, 0);

    ###
      Если на странице определен общий вывод списка сообщений - то используем его для отображения ошибки. Иначе - ипользуем стандартный контейнер внутри формы, который должен иметь класс form-result-fail
    ###
    badMessage: (data)->
      if !@page || !@page.isMessageBoxAvailable || !@page.isMessageBoxAvailable()
        @newInFormMessage("form-result-fail", data)
      else @page.badMessage(data)

    ###
      Если на странице определен общий вывод списка сообщений - то используем
      его для отображения сообщения. Иначе - ипользуем стандартный контейнер внутри формы, который должен иметь класс form-result-success
    ###
    goodMessage: (data)->
      if !@page || !@page.isMessageBoxAvailable || !@page.isMessageBoxAvailable()
        @newInFormMessage("form-result-success", data)
      else @page.goodMessage(data)

    setPreExecute: (preExecute)->
      @preExecute = preExecute

    setOnDone: (onDone)->
      @onDone = onDone

    ###
      Функция отправки формы. Вызывается на событие submit и содержит вызовы
      всех дополнительных обработчиков
    ###
    send: (opt)->
      # Обновляем содержание полей ckeditor'а
      $(@form).find('textarea.ckeditor').each ()->
         $textarea = $(this);
         $textarea.val(CKEDITOR.instances[$textarea.attr('name')].getData());

      return if !validate(@form)
      if @page && @page.loading
        @page.loading()
      @get(opt) if @isGET
      @post(opt) if @isPOST

    ###
      Отпрвка POST, multipart/request формы
    ###
    post: (opt)=>

      getData = ()=>

        data = new FormData @form[0]
        if ($(@form[0]).children("a[action='submit']").text() != "Оформить подписку")
            index = 0
            for newAttachment in @stack.getFiles()
              newAttachment.appendValue("#{@dbName}_file_#{index}", data)
              index++

            for removed in $(".to-remove")
              data.append("remove_#{@dbName}_file[]", $(removed).attr('data-id'))


            if @dbName && window[@dbName] && window[@dbName]["onPreExecute"]
              window[@dbName]["onPreExecute"].call(this, data)

            if @preExecute
              @preExecute(data)
            else if window[@preExecuteName]
              window[@preExecuteName](data)

            data
        else
            $(@form[0]).serialize()

      sender = (data)=>
        customContentType = false
        data = getData() if !data
        if ($(@form[0]).children("a[action='submit']").text() == "Оформить подписку")
            customContentType = "application/x-www-form-urlencoded; charset=UTF-8"
        $.ajax({
            url:@href+"?ts=#{new Date().getTime()}",
            type: 'POST',
            data: data,
            headers: { "cache-control": "no-cache" }
            contentType: customContentType,
            processData: false
          })
          .done (data, status, xhr)=>
            @done(data, opt, xhr)
          .fail (data)=>
            @fail(data, opt)



      if window[@dbName] && window[@dbName]["beforeDataCreated"]
        return if window[@dbName]["beforeDataCreated"].call(this, sender)

      data = getData()

      if window[@dbName] && window[@dbName]["onSubmit"]
        return if window[@dbName]["onSubmit"].call(this, data, sender)

      sender(data)



    get: (opt)->
      $.get(@href+"?ts=#{new Date().getTime()}&#{@form.serialize()}")
      .done (data, status, xhr)=>
        @done(data, opt, xhr)
      .fail (data)=>
        @fail(data, opt)

    done: (data, opt, xhr)=>
      opt = opt || {}

      if @page && @page.loaded
        @page.loaded()

      redirect = xhr.getResponseHeader("Redirect");
      if redirect
        document.location = redirect;
        return;

      if window[@dbName] && window[@dbName]["onDone"]
        return if window[@dbName]["onDone"](data, opt)

      message = @successMessage || data

      try
        jsonData = $.parseJSON(data)
      catch error
        jsonData = data
      if jsonData._message
        if jsonData._message.type == 0
          @goodMessage(jsonData._message.text)
        else
          @badMessage(jsonData._message.text)
      else
        @goodMessage(message)

      if !reloadBinded
        reloadBinded = true
        $(".ajax-form").on "dialogclose", ()->
          if @page && @page.loading
            @page.loading()
          window.location.reload()

      if @dbName && window[@dbName] && window[@dbName]["onStateChanged"] && opt && opt.state
        if (window[@dbName]["onStateChanged"](jsonData, opt.state))
          clearForm(@form) if opt.clear
          fill(@form, jsonData) if opt.edit
          if opt.state == "copy"
            $(@form).find("input[name=#{@dbName}_id]").val("")
          return;
      if window[@stateChangeHandlerName] && opt && opt.state
        window[@stateChangeHandlerName](jsonData, opt.state)
      if @dbName && opt && opt.state == "copy"
        $(@form).find("input[name=#{@dbName}_id]").val("")

      # Опции указывают, что после выполнения нужно вернуться назад.
      # Создано в первую очередь для обработки кнопки "сохранить"
      if opt && opt.back
        if @isHandlerExist('onStateBack')
          return if @formFunctions()['onStateBack']()
        if opt.reload == 'true'
          window.location.reload()
          return
        @page.goBack()

      if typeof opt.reload == 'function'
        opt.reload();

      clearForm(@form) if opt && opt.clear
      fill(@form, jsonData) if opt && opt.edit

    formFunctions: ()->
      window[@dbName]

    isHandlerExist: (handlerName)->
      @dbName && @formFunctions() && @formFunctions()[handlerName]

    fail: (data, opt)=>
      if @page && @page.loaded
        @page.loaded()
      @formFail = @submitter.find(".form-result-fail")
      if window.smartCaptcha?
        window.smartCaptcha.reset(0)
        try window.smartCaptcha.reset(1)
      try
        jsonData = $.parseJSON(data)
      catch error
        jsonData = data
      if @page && @page.badMessage
        @page.badMessage(data.responseText)

  $ ->
    reloadBinded = false
    if (! window.ajaxForms)
      window.ajaxForms = []
    $('.ajax-form').each ()->
      window.ajaxForms.push new AjaxForm(window.page, $(this))

    $(".ajax-form").off "submit"
    $("body").on 'submit', ".ajax-form", (e)->

      return if (!new XMLHttpRequest().upload)

      e.preventDefault()
      for form in window.ajaxForms
        if form.form[0] == $(this).closest("form")[0]
          form.send()
          return;
      newForm = new AjaxForm(page, $(this))
      window.ajaxForms.push newForm
      newForm.send()

    $(".combo-input").not(".no-create").each ()->
      new ComboBox $(this)

unit.define "std::ajaxform", module, "std::combobox", "std::fields", "std::file-field", "std::admin-page", "std::multi-combo-box"
